import PropTypes from 'prop-types'
import React from 'react'
import { StyledErrorLabel } from './FormFieldError.styled'

/**
 * FormFieldError Component
 * Displays validation errors using Semantic UI Label with custom styling
 * Matches original OrderEditor error styling exactly
 */
export const FormFieldError = ({ error, show }) => {
  if (!show || !error) {
    return null
  }

  return (
    <StyledErrorLabel
      floating
      basic
      color='red'
      pointing='below'
      data-testid='form-field-error'
    >
      {error}
    </StyledErrorLabel>
  )
}

FormFieldError.propTypes = {
  error: PropTypes.string,
  show: PropTypes.bool,
}

FormFieldError.defaultProps = {
  error: '',
  show: false,
}
